import React from "react";
import currencyFormatter from "currency-formatter";
import { AllHtmlEntities } from "html-entities";
import Modal from "../../components/Modal";
import Button from "../../components/inputs/Button";
import Checkbox from "../../components/inputs/Checkbox";
import Textfield from "../../components/inputs/Textfield";
import moment from "moment";
import { connect } from "react-redux";
import { updateCart } from "../../actions/actions";
import Cookies from "js-cookie";

const entities = new AllHtmlEntities();

class ShoppingCartItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
    this._onRemove = this._onRemove.bind(this);
    this._submitUpdate = this._submitUpdate.bind(this);
    this._onUpdateQuantity = this._onUpdateQuantity.bind(this);
  }
  _onRemove() {
    this.props.onRemove(this.props.index);
  }
  _submitUpdate() {
    this.setState({
      modalOpen: false
    });

    const kref = this._kref._input.value || "";
    const code = this._code._input.value || "";
    const copy = this._copy._input.value || "1";
    const urgt = this._urgt._input.checked ? "1" : "0";
    const details = this._details._input.value || "";

    this.props.updateCart(Cookies.get("subaccount"), this.props.index, {
      isbn: this.props.item.isbn || "",
      titl: this.props.item.titl || "",
      auth: this.props.item.auth || "",
      kdat: moment().format("DD.MM.YYYY"),
      pdat: this.props.item.pdat || "",
      weig: this.props.item.weig || "",
      publ: this.props.item.publ || "",
      code: code.toUpperCase(),
      kref,
      copy,
      urgt,
      detl: details
    });
  }
  _onUpdateQuantity() {
    this.props.onUpdateQuantity(this.props.index, this._inputQuantity.value);
  }
  render() {
    return (
      <div className="shopping-cart-item">
        <div className="item-isbn">{this.props.isbn}</div>
        <div className="item-title">{this.props.title}</div>
        {this.props.konto && (
          <div>
            <b>Sub-Account:</b> {this.props.konto}
          </div>
        )}
        {this.props.budgetCode && (
          <div>
            <b>Budget Code:</b> {this.props.budgetCode}
          </div>
        )}
        {this.props.reference && (
          <div>
            <b>Reference:</b> {this.props.reference}
          </div>
        )}
        {this.props.ebrary && (
          <div>
            <b>Licence:</b> {this.props.ebrary}
          </div>
        )}
        {this.props.author && (
          <div className="item-author">
            {typeof this.props.author == "object" &&
            this.props.author.length > 0 ? (
              <span>by </span>
            ) : null}
            {typeof this.props.author == "object" &&
              this.props.author &&
              this.props.author.map((item, index) => {
                if (!item) {
                  return;
                } else if (index == 0) {
                  return <span key={index}>{entities.decode(item)}</span>;
                } else {
                  return <span key={index}>, {entities.decode(item)}</span>;
                }
              })}
          </div>
        )}
        <div className="item-footer">
          <div className="item-inputs">
            {this.props.item.editable ? (
              <input
                ref={node => (this._inputQuantity = node)}
                type="number"
                min="1"
                className="item-quantity"
                defaultValue={this.props.quantity}
                key={this.props.quantity}
                onChange={this._onUpdateQuantity}
              />
            ) : null}
            {this.props.item.editable ? (
              <button
                type="button"
                className="item-refresh"
                onClick={this._onUpdateQuantity}
              >
                <img src="/images/icons/refresh.png" alt="" />
              </button>
            ) : null}
            {this.props.item.editable ? (
              <button
                type="button"
                className="item-edit"
                onClick={() =>
                  this.setState({
                    modalOpen: true
                  })
                }
              >
                <Modal open={this.state.modalOpen}>
                  <Textfield
                    ref={node => (this._kref = node)}
                    placeholder="Your Reference"
                    defaultValue={this.props.item.kref}
                  />
                  <Textfield
                    ref={node => (this._code = node)}
                    placeholder="Your Budget Code"
                    autocompleteBudgetCode={Cookies.get("subaccount")}
                    defaultValue={this.props.item.code}
                  />
                  <Textfield
                    type="number"
                    ref={node => (this._copy = node)}
                    placeholder="Copies"
                    defaultValue={this.props.item.copy}
                  />
                  <Textfield
                    ref={node => (this._kdat = node)}
                    disabled={true}
                    value={moment().format("DD.MM.YYYY")}
                    placeholder="Order Date"
                  />
                  <Checkbox
                    ref={node => (this._urgt = node)}
                    onClick={value => value}
                    value="1"
                    label="Urgent"
                    name={`urgent_${this.props.isbn}_${this.props.index}`}
                  />
                  <Textfield
                    type="textarea"
                    ref={node => (this._details = node)}
                    placeholder="Details"
                    defaultValue={this.props.item.detl}
                  />
                  <div className="button-wrapper">
                    <Button
                      type="danger"
                      onClick={() =>
                        this.setState({
                          modalOpen: false
                        })
                      }
                    >
                      Cancel
                    </Button>
                    <Button type="primary" onClick={this._submitUpdate}>
                      Update
                    </Button>
                  </div>
                </Modal>
                <img src="/images/icons/edit.png" alt="" />
              </button>
            ) : null}
            {this.props.item.editable ? (
              <button
                type="button"
                className="item-remove"
                onClick={this._onRemove}
              >
                <img src="/images/icons/delete.png" alt="" />
              </button>
            ) : null}
          </div>
          <div className="item-price">
            {currencyFormatter.format(this.props.price * this.props.quantity, {
              symbol: this.props.currency,
              decimal: ",",
              thousand: ".",
              precision: 2,
              format: "%v %s" // %s is the symbol and %v is the value
            })}
          </div>
        </div>
      </div>
    );
  }
}

ShoppingCartItem.propTypes = {
  updateCart: React.PropTypes.func.isRequired,
  index: React.PropTypes.number.isRequired,
  isbn: React.PropTypes.string.isRequired,
  title: React.PropTypes.string.isRequired,
  price: React.PropTypes.number.isRequired,
  quantity: React.PropTypes.number.isRequired,
  onRemove: React.PropTypes.func.isRequired,
  onUpdateQuantity: React.PropTypes.func.isRequired,
  author: React.PropTypes.array,
  konto: React.PropTypes.string,
  currency: React.PropTypes.string,
  budgetCode: React.PropTypes.string,
  reference: React.PropTypes.string,
  ebrary: React.PropTypes.string,
  item: React.PropTypes.object
};

ShoppingCartItem.defaultProps = {
  quantity: 1
};

const mapDispatchToProps = dispatch => {
  return {
    updateCart: (subaccount, index, item) => {
      dispatch(updateCart(subaccount, index, item));
    }
  };
};

export default connect(null, mapDispatchToProps)(ShoppingCartItem);



// WEBPACK FOOTER //
// ./src/js/components/shoppingCart/ShoppingCartItem.js